module.exports = __webpack_public_path__ + "img/icon-empty-box@2x.f3cfcdb1.png";